// extracted by mini-css-extract-plugin
module.exports = {"section":"LatestEvents_section__2ziXX","header":"LatestEvents_header__2PnGl","title":"LatestEvents_title__1eV-2","description":"LatestEvents_description__1VHZo"};